import { AddTask, NoteAlt } from "@mui/icons-material";
import AccountBoxIcon from "@mui/icons-material/AccountBox";
import ContentPasteIcon from "@mui/icons-material/ContentPaste";
import ReceiptIcon from "@mui/icons-material/Receipt";
import SimCardDownloadIcon from "@mui/icons-material/SimCardDownload";
import TableViewIcon from "@mui/icons-material/TableView";
import ViewKanbanIcon from "@mui/icons-material/ViewKanban";
import {
	Avatar,
	Button,
	Checkbox,
	IconButton,
	ToggleButton,
	ToggleButtonGroup,
	Tooltip,
	Typography,
	useTheme,
} from "@mui/material";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { GenderObjects } from "../Enums/Gender";
import CreateCandidateModal from "../components/CreateCandidateModal";
import CreateInterviewModal from "../components/CreateInterviewModal";
import CreateResumeModal from "../components/CreateResumeModal";
import CreateTaskModal from "../components/CreateTaskModal";
import CustomTable from "../components/CustomTable";
import PeriodSelector from "../components/DataInputs/DataPeriodSelector";
import DataSelect from "../components/DataInputs/DataSelect";
import DataSwitch from "../components/DataInputs/DataSwitch";
import DataTextField from "../components/DataInputs/DataTextField";
import EditMenu from "../components/EditMenu";
import FilterBase from "../components/Filter";
import Kanban from "../components/Kanban";
import RequestCard from "../components/RequestCard";
import UpdateRequestModal from "../components/UpdaRequestModal";
import usePagination, { InfinityPagination } from "../hooks/Pagination";
import { CandidateSearch, CandidateTable } from "../interfaces/Candidate";
import { ManagerSearch, ManagerTable } from "../interfaces/Manager";
import Region, { City } from "../interfaces/Region";
import {
	RequestFilter,
	RequestSearch,
	RequestTable,
} from "../interfaces/Request";
import {
	ArrayContainer,
	Filter,
	Pagination,
	ResponseContainer,
	Sort,
} from "../interfaces/RequestBase";
import Resume from "../interfaces/Resume";
import { Status } from "../interfaces/Status";
import { TableTemplate } from "../interfaces/Table";
import { VacancyTable } from "../interfaces/Vacancy";
import {
	GetCandidates,
	GetManagers,
	GetRegions,
	GetRequest,
	GetRequests,
	GetResume,
	GetStatuses,
	GetVacancies,
	UpdateRequest,
} from "../requester/functions";
import { MAIN_URL, P } from "../requester/requester";
import { getStatusColor } from "../utilities/color";
import dateToHuman, { getPeriodColor } from "../utilities/date";
import getFilter from "../utilities/filter";

const RequestsPage = () => {
	const [pagination, setPage, setPageSize] = usePagination();
	const theme = useTheme();

	const [isKanban, setKanban] = useState(false);

	const [totalCount, setTotalCount] = useState<number>(0);

	const [searchManager, setSearchManager] = useState<ManagerSearch>({});
	const [searchCandidate, setSearchCandidate] = useState<CandidateSearch>({});

	const [requests, setRequests] = useState<RequestTable[]>([]);
	const [filter, setFilter] = useState<RequestFilter>({});
	const [search, setSearch] = useState<RequestSearch>({});
	const [sort, setSort] = useState<Sort>({});
	const [candidates, setCandidates] = useState<CandidateTable[]>([]);

	const [cities, setCities] = useState<City[]>([]);
	const [regions, setRegions] = useState<Region[]>([]);
	const [status, setStatus] = useState<Status[]>([]);
	const [vacancy, setVacancy] = useState<VacancyTable[]>([]);
	const [managers, setManagers] = useState<ManagerTable[]>([]);

	const [openModal, setOpenModal] = useState<boolean>(false);

	const [selectedRequest, setSelectedRequest] = useState<RequestTable | null>();
	const [selectedRequests, setSelectedRequests] = useState<number[]>([]);

	const [selectedResume, setSelectedResume] = useState<Resume>();

	const [selectedUserId, setSelectedUserId] = useState<number>();

	const [taskRequest, setTaskRequest] = useState<RequestTable | undefined>(
		undefined
	);

	const [interviewRequest, setInterviewRequest] = useState<
		RequestTable | undefined
	>(undefined);

	const [recommendedCandidate, setRecommendedCandidate] =
		useState<CandidateTable | null>(null);

	const renderCard = (data: RequestTable) => (
		<RequestCard
			key={`request-card-${data.id}`}
			request={data}
			selectRequest={setSelectedRequest}
			selectedRequests={selectedRequests}
			setSelectedRequests={setSelectedRequests}
		/>
	);

	const getRequest = (id: number) => {
		GetRequest({ id }, (resp) => {
			if (resp.status === "ok" && resp.data) {
				setSelectedRequest(resp.data);
			}
		});
	};

	const getRequests = () => {
		var req: Filter<RequestFilter, RequestSearch> = getFilter(
			pagination as Pagination,
			filter,
			search,
			sort
		);
		GetRequests(req, (req) => {
			if (req.status === "ok" && req.data) {
				setRequests(req.data.data);
				setTotalCount(req.data?.total_count || 0);
			}
		});
	};

	const getRequestsExport = (callback: any) => {
		var req: Filter<RequestFilter, RequestSearch> = getFilter(
			{ page: 0, size: totalCount } as Pagination,
			filter,
			search,
			sort
		);
		GetRequests(req, (req) => {
			if (req.status === "ok" && req.data) {
				callback(req.data.data);
			}
		});
	};

	const renderManager = (
		item: any,
		index: number,
		selectedId: number,
		rowId: number
	) => (
		<div
			key={`manager-${index}`}
			className="flex items-center w-full gap-3 rounded-lg px-1 py-1 cursor-pointer"
			style={
				selectedId === item.id
					? { border: "solid 2px", borderColor: theme.palette.primary.main }
					: {}
			}
			onClick={() => {
				setManager(item.id, rowId);
			}}
		>
			<Avatar src={`${MAIN_URL}manager/avatar/${item.avatar}`} />
			<Typography>
				{item.last_name} {item.first_name}
			</Typography>
		</div>
	);

	const renderCandidate = (
		item: any,
		index: number,
		selectedId: number,
		rowId: number
	) => (
		<div
			key={`manager-${index}`}
			className="flex items-center w-full gap-3 rounded-lg px-1 py-1 cursor-pointer"
			style={
				selectedId === item.id
					? { border: "solid 2px", borderColor: theme.palette.primary.main }
					: {}
			}
			onClick={() => {
				setCandidate(item.id, rowId);
			}}
		>
			<Avatar src={`${MAIN_URL}manager/avatar/${item.avatar}`} />
			<Typography>
				{item.last_name} {item.first_name}
			</Typography>
		</div>
	);

	const renderRecommendatedCandidate = (item: any) => {
		return (
			<div className="w-full">
				{item ? (
					<div
						className="flex items-center w-full gap-3 rounded-lg px-1 py-1"
						style={{
							border: "solid 2px",
							borderColor: theme.palette.warning.main,
						}}
						onClick={() => {
							setCandidate(item.candidate.id, item.id);
						}}
					>
						<Avatar src={`${MAIN_URL}manager/avatar/${item.avatar}`} />
						<Typography>
							{item.last_name} {item.first_name}
						</Typography>
					</div>
				) : null}

				<Button
					onClick={() => {
						setOpenModal(true);
					}}
				>
					Создать
				</Button>
			</div>
		);
	};

	const getRecommendedCandidate = (item: any, setter: any) => {
		GetCandidates(
			{
				pagination: { page: 0, size: 10 },
				search_by: { email: item.candidate.email },
			},
			(resp) => {
				if (resp.status === "ok" && resp.data) {
					if (resp.data.data.length > 0) {
						setter({ ...resp.data.data[0] });
					} else setRecommendedCandidate(null);
				}
			}
		);
	};

	const renderStatus = (
		item: any,
		index: number,
		selectedId: number,
		rowId: number
	) => (
		<div
			key={`status-${index}`}
			className="flex items-center w-full gap-3 rounded-lg px-1 py-1 cursor-pointer"
			style={
				selectedId === item.id
					? { border: "solid 2px", borderColor: theme.palette.primary.main }
					: {}
			}
			onClick={() => {
				setRequestStatus(item.id, rowId);
			}}
		>
			<Typography>{item.name}</Typography>
		</div>
	);

	const onRequestUpdate = (resp: ResponseContainer<null>) => {
		if (resp.status === "error") console.error(resp.message);
		else getRequests();
	};

	const setKanbanStatus = (item: RequestTable, key: string) => {
		const currentStatus = status.find((s) => s.name === key);

		var statusId: number = 0;
		if (currentStatus) {
			statusId = currentStatus.id;
		}
		UpdateRequest(
			{
				id_status: statusId,
				id: selectedRequests.length === 0 ? [item.id] : selectedRequests,
			},
			(resp) => {
				onRequestUpdate(resp);
			}
		);
	};

	const setManager = (id: number, request_id: number) => {
		UpdateRequest(
			{
				id_manager: id,
				id: selectedRequests.length === 0 ? [request_id] : selectedRequests,
			},
			(resp) => {
				onRequestUpdate(resp);
			}
		);
	};

	const setCandidate = (id: number, request_id: number) => {
		UpdateRequest(
			{
				id_candidate: id,
				id: selectedRequests.length === 0 ? [request_id] : selectedRequests,
			},
			(resp) => {
				onRequestUpdate(resp);
			}
		);
	};
	const setRequestStatus = (id: number, request_id: number) => {
		var send_mail = window.confirm(
			"Оповестить пользователя по почте об изменения статуса?"
		);
		UpdateRequest(
			{
				id_status: id,
				id: selectedRequests.length === 0 ? [request_id] : selectedRequests,
				send_mail: send_mail,
			},
			(resp) => {
				onRequestUpdate(resp);
			}
		);
	};

	const changeView = (
		event: React.MouseEvent<HTMLElement>,
		newAlignment: boolean
	) => {
		setKanban(newAlignment);
	};

	const getRegions = () => {
		GetRegions({}, (resp) => {
			if (resp.status === "ok" && resp.data) {
				setRegions(resp.data);
			}
		});
	};

	const columns: TableTemplate = {
		rowStyle: (item: RequestTable) => {
			var color = getPeriodColor(item.last_update);
			if (color) return { backgroundColor: color };
			return {};
		},
		data: [
			{
				title: "",
				render: (item: RequestTable) => (
					<Checkbox
						checked={selectedRequests?.indexOf(item.id) !== -1}
						onChange={() => {
							var index: any = selectedRequests?.indexOf(item.id);

							var eventSelected: any = selectedRequests;
							if (index !== -1) {
								eventSelected?.splice(index, 1);
							} else {
								eventSelected?.push(item.id);
							}
							setSelectedRequests([...eventSelected]);
						}}
					/>
				),
			},
			{
				title: "ФИО",
				sortKey: "user.last_name",
				renderExport: (item: RequestTable) =>
					item.candidate?.full_name || "Аноним",
				render: (item: RequestTable) =>
					!item.candidate.id ? (
						<EditMenu
							renderElement={renderCandidate}
							data={candidates}
							search={searchCandidate.full_name}
							selectedId={item.candidate.id}
							item={item}
							getRecommended={getRecommendedCandidate}
							recommended={recommendedCandidate}
							renderRecommended={renderRecommendatedCandidate}
							setSearch={function (value: string) {
								setSearchCandidate((s) => {
									s.full_name = value;
									return { ...s };
								});
							}}
						>
							<div className="flex">
								<Typography
									className="px-2 py-1 rounded-md"
									style={
										!item.candidate.id
											? {
													backgroundColor: theme.palette.info.main,
													color: "white",
											  }
											: {}
									}
								>
									{item.candidate.full_name ? item.candidate.full_name : "Нет"}{" "}
								</Typography>
							</div>
						</EditMenu>
					) : item.candidate.full_name ? (
						item.candidate.full_name
					) : (
						"Нет"
					),
			},
			{
				title: "Телефон",
				key: "phone",
			},
			{
				title: "Дата создания",
				sortKey: "creation_date",
				render: (item) => dateToHuman(item.creation_date),
			},
			{
				title: "Отвественный",
				sortKey: "manager.last_name",
				renderExport: (item: RequestTable) => item.manager.full_name || "Нет",
				render: (item: RequestTable) => (
					<EditMenu
						renderElement={renderManager}
						data={managers}
						search={searchManager.full_name}
						selectedId={item.manager.id}
						item={item}
						setSearch={function (value: string) {
							setSearchManager((s) => {
								s.full_name = value;
								return { ...s };
							});
						}}
					>
						{item.manager.full_name || "Нет"}
					</EditMenu>
				),
			},
			{
				title: "Город",
				sortKey: "city",
				render: (item: RequestTable) => `${item.region}/${item.city}`,
			},
			{
				title: "Вакансия",
				sortKey: "vacancy",
				render: (item: RequestTable) => item.vacancy.name,
			},
			{
				title: "Повтор",
				sortKey: "repeat",
				render: (item: RequestTable) => (item.repeat ? "Да" : "Нет"),
			},
			{
				title: "Статус",
				sortKey: "status",
				renderExport: (item: RequestTable) => item.status.name || "Нет",
				render: (item: RequestTable) => (
					<EditMenu
						renderElement={renderStatus}
						data={status}
						selectedId={item.status.id}
						item={item}
						hideSearch
					>
						{item.status.name ? (
							<Typography
								style={{
									backgroundColor: getStatusColor(item.status.id),
									color: "white",
								}}
								className="px-3 py-1 rounded-md text-white"
							>
								{item.status.name}
							</Typography>
						) : (
							"Нет"
						)}
					</EditMenu>
				),
			},
			{
				title: "Кандидат",
				noExport: true,
				render: (item: RequestTable) =>
					item.candidate.id ? (
						<Tooltip title={"Страница кандидата"}>
							<Link to={`/candidate/${item.candidate.id}`}>
								<AccountBoxIcon />
							</Link>
						</Tooltip>
					) : (
						"Нет"
					),
			},
			{
				title: "Заявка",
				noExport: true,
				render: (item: RequestTable) =>
					item.candidate.id ? (
						<Tooltip title={"Заявка"}>
							<IconButton
								onClick={() => {
									GetRequest({ id: item.id }, (resp) => {
										if (resp.status === "ok" && resp.data) {
											setSelectedRequest(resp.data);
										}
									});
								}}
							>
								<ReceiptIcon />
							</IconButton>
						</Tooltip>
					) : (
						"Нет"
					),
			},
			{
				title: "Файл",
				noExport: true,
				render: (item: RequestTable) =>
					item.doc ? (
						<Tooltip title={"Скачать файл"}>
							<a
								href={`${MAIN_URL}${P.DownloadFile}/${item.doc}`}
								download={"true"}
							>
								<SimCardDownloadIcon />
							</a>
						</Tooltip>
					) : (
						"Нет"
					),
			},
			{
				title: "Резюме",
				noExport: true,
				render: (item: RequestTable) =>
					item.id_resume ? (
						<Tooltip title={"Резюме"}>
							<IconButton
								onClick={() => {
									GetResume({ id: item.id_resume || 0 }, (resp) => {
										if (resp.status === "ok" && resp.data) {
											setSelectedUserId(item.candidate.id);
											setSelectedResume(resp.data);
										}
									});
								}}
							>
								<ContentPasteIcon />
							</IconButton>
						</Tooltip>
					) : (
						"Нет"
					),
			},
			{
				title: "Задача",
				noExport: true,
				render: (item) => (
					<Tooltip title="Создать задачу">
						<IconButton
							onClick={() => {
								setTaskRequest(item);
							}}
						>
							<AddTask />
						</IconButton>
					</Tooltip>
				),
			},
			{
				title: "Интервью",
				noExport: true,
				render: (item) => (
					<Tooltip title="Назначить интервью">
						<IconButton
							onClick={() => {
								setInterviewRequest(item);
							}}
						>
							<NoteAlt />
						</IconButton>
					</Tooltip>
				),
			},
		],
	};

	useEffect(() => {
		GetRegions({}, (resp) => {
			if (resp.status === "ok" && resp.data) {
				var eventRegions: City[] = [];
				resp.data.forEach((r) => {
					eventRegions.push(...r.cities);
				});

				setCities(eventRegions);
			}
		});

		getRegions();

		GetStatuses({ filter_by: { type: "request" } }, (resp) => {
			if (resp.status === "ok" && resp.data) {
				setStatus(resp.data);
			}
		});

		GetVacancies(
			{
				filter_by: { all_vacancies: true },
				pagination: InfinityPagination,
			},
			(resp) => {
				if (resp.status === "ok" && resp.data) {
					setVacancy(resp.data.data);
				}
			}
		);
	}, []);

	const getCandidates = () => {
		GetCandidates(
			{
				search_by: searchCandidate,
				pagination: {
					page: 0,
					size: 50,
				},
			},
			(resp: ResponseContainer<ArrayContainer<CandidateTable>>) => {
				if (resp.status === "ok" && resp.data) {
					setCandidates(resp.data.data);
				}
			}
		);
	};

	useEffect(() => {
		getCandidates();
	}, [searchCandidate]);

	useEffect(() => {
		GetManagers(
			{
				search_by: searchManager,
				pagination: { page: 0, size: 50 },
			},
			(resp) => {
				if (resp.status === "ok" && resp.data) {
					setManagers(resp.data.data);
				}
			}
		);
	}, [searchManager]);

	useEffect(() => {
		getRequests();
	}, [filter, pagination, search, sort]);

	return (
		<div className="flex flex-col items-end gap-5">
			<div className="w-full flex justify-between">
				<div className="flex gap-2">
					<ToggleButtonGroup
						value={isKanban}
						exclusive
						onChange={changeView}
						aria-label="text alignment"
					>
						<ToggleButton value={false} aria-label="left aligned">
							<TableViewIcon />
						</ToggleButton>
						<ToggleButton value={true} aria-label="centered">
							<ViewKanbanIcon />
						</ToggleButton>
					</ToggleButtonGroup>
					<Button
						variant="contained"
						onClick={() => {
							setSelectedRequests(requests.map((r) => r.id));
						}}
					>
						Выделить все
					</Button>
					{selectedRequests.length > 0 ? (
						<Button
							variant="contained"
							color="error"
							onClick={() => {
								setSelectedRequests([]);
							}}
						>
							Убрать выделение
						</Button>
					) : null}
				</div>
				<FilterBase setSearch={setSearch} setFilter={setFilter}>
					<DataTextField
						keyValue={"candidate_name"}
						value={search}
						setValue={setSearch}
						inputProps={{ label: "Поиск кандидата" }}
					/>
					<DataTextField
						keyValue={"manager_name"}
						value={search}
						setValue={setSearch}
						inputProps={{ label: "Поиск менеджера" }}
					/>
					<PeriodSelector
						value={filter}
						setValue={setFilter}
						keyValue="created"
					/>
					<DataSelect
						keyValue={"id_region"}
						list={regions}
						value={filter}
						setValue={setFilter}
						label="Регион"
					/>
					<DataSelect
						keyValue={"id_city"}
						list={cities}
						value={filter}
						setValue={setFilter}
						label="Город"
					/>

					<DataSelect
						keyValue={"id_status"}
						list={status}
						value={filter}
						setValue={setFilter}
						label="Статус"
					/>
					<DataSelect
						keyValue={"id_vacancy"}
						list={vacancy}
						value={filter}
						setValue={setFilter}
						label="Вакансия"
					/>
					<DataSwitch
						value={filter}
						setValue={setFilter}
						keyValue={"repeat"}
						label="Повторные"
					/>
					<DataSelect
						value={filter}
						keyValue={"gender"}
						list={GenderObjects}
						keyItem={"value"}
						keyTitle={"label"}
						setValue={setFilter}
						label="Пол"
					/>
				</FilterBase>
			</div>

			{!isKanban ? (
				<CustomTable
					rows={columns}
					data={requests}
					allCount={totalCount}
					pagination={pagination as Pagination}
					setPage={setPage as (p: number) => void}
					setPageSize={setPageSize as (p: number) => void}
					sort={sort}
					setSort={setSort}
					onExport={getRequestsExport}
				/>
			) : (
				<Kanban
					data={requests}
					statusKey={"status"}
					renderComponent={renderCard}
					changeEvent={setKanbanStatus}
					columnsData={status.map((s) => s.name)}
					extractKey={(obj) => obj.status.name}
				/>
			)}
			<CreateCandidateModal
				open={openModal}
				onClose={() => setOpenModal(false)}
				onCreate={() => {
					getCandidates();
				}}
			/>
			<UpdateRequestModal
				open={selectedRequest != null}
				onClose={() => {
					setSelectedRequest(null);
				}}
				request={selectedRequest || undefined}
				userId={selectedRequest?.candidate.id || 0}
				onUpdate={(id) => {
					getRequest(id);
				}}
			/>
			<CreateResumeModal
				open={selectedResume ? true : false}
				resume={selectedResume}
				userId={selectedUserId || 0}
				onClose={() => {
					setSelectedResume(undefined);
				}}
			/>
			<CreateTaskModal
				open={taskRequest ? true : false}
				onClose={() => {
					setTaskRequest(undefined);
				}}
				userId={0}
				request={taskRequest}
			/>
			<CreateInterviewModal
				open={interviewRequest ? true : false}
				onClose={() => {
					setInterviewRequest(undefined);
				}}
				userId={0}
				request={interviewRequest}
			/>
		</div>
	);
};

export default RequestsPage;
